export enum ScheduleType {
  repeating = 'REP',
  oneOff = 'ONE',
  rolling = 'ROL'
}

export enum EventTypeStatus {
    draft = 'DRA',
    active = 'ACT',
    retired = 'RET'
}

export enum EventTypeWaitlistScope {
  event = 'EVN',
  eventType = 'EVT',
}

export enum EventQuestionScope {
  participant = 'PAR',
  bookingCustomer = 'BOO',
}

export enum EventQuestionType {
    preferredName = 'PNM',
    singleLineText = 'SLT',
    multipleLineText = 'MLT',
    multipleChoice = 'MCH',
    singleCheckbox = 'SCK',
    multipleCheckboxes = 'MCK',
    customCustomerField = 'CCF'
}

export enum EventScheduleRepetition {
    weekly = 'WKL',
    biweekly = 'BWK',
    monthlyFirstDays = 'M1',
    monthlySecondDays = 'M2',
    monthlyThirdDays = 'M3',
    monthlyFourthDays = 'M4',
    monthlyLastDays = 'ML'
}

export enum EventDiscountType {
    currency = 'CUR',
    percentage = 'PER'
}

export enum ScheduledEventsColumnType {
    reservationEmail = 'EMAIL',
    payment = 'PAYMENT',
    feeType = 'FEE_TYPE',
    addOns = 'ADD_ONS',
    bookedBy = 'BOOKED_BY',
    hasEmergencyContact = 'HAS_EMERGENCY_CONTACT',
    medicalNotes = 'MEDICAL_NOTES',
    capitanProfileField = 'CAPITAN_PROFILE_FIELD',
    customCustomerField = 'CUSTOM_CUSTOMER_FIELD',
    attendeeQuestion = 'ATTENDEE_QUESTION'
}

export enum CurrencyRefundAmount {
  full = 'FUL',
  perParticipantFeeOnly = 'PPF',
  perBookingFeeOnly = 'PBF',
  noRefund = 'NOR',
}
